import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1753a9e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b1753a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1753a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1753a9e')) {
      api.createRecord('b1753a9e', component.options)
    } else {
      api.reload('b1753a9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1753a9e&scoped=true&", function () {
      api.rerender('b1753a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/relatedApproval/index.vue"
export default component.exports